import React from "react";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {Card, DescriptionList, DescriptionListItem, SimpleCardHeading} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";

/**
 * Takeaway: where the customer picks up the order.
 */
const TakeawayAddressCard = () => {
    const intl = useIntl();
    const {dashboardLocation} = useRestaurant();

    return (
        <Card
            header={
                <CardHeader>
                    <SimpleCardHeading title={<FormattedMessage id={"takeawayAddress"}/>}/>
                </CardHeader>
            }
        >
            <DescriptionList compact={true}>
                <DescriptionListItem
                    compact={true}
                    title={intl.formatMessage({id: "restaurant"})}
                    content={dashboardLocation.name}
                />
                <DescriptionListItem
                    compact={true}
                    title={intl.formatMessage({id: "address"})}
                    content={
                        <>
                            {dashboardLocation.addressLine1}<br/>
                            {dashboardLocation.addressLine2}
                        </>
                    }
                />
                <DescriptionListItem
                    compact={true}
                    title={intl.formatMessage({id: "payment"})}
                    content={intl.formatMessage({id: "customerPaysAtPickup"})}
                />
            </DescriptionList>
        </Card>
    );
};

export default TakeawayAddressCard;